export default {
    switchStore(state, payload) {
        state.SF_CATCLASS = payload.CATNAME;
        switch (payload.CATCLASS.toUpperCase()) {
            case 'WHI':
                state.STORE_FRONT = 'whi';
                break;
            case 'WHIACES':
                state.STORE_FRONT = 'whi';
                break;
            case 'PARTSLINK':
                state.STORE_FRONT = 'Partslink';
                break;
        }
    },
}